import React from "react";
import styles from './CohortTimeframe.module.scss'
import { Col, Row } from "antd";
import { getCurrent } from "../../reducers/util";
import {useDispatch, useSelector} from "react-redux";
import {Dispatch} from "redux";
import {changeQueryPeriod} from "../../containers/CohortBuilder/cohortBuilderSlice";
import {calculateTotalPatientCount} from "./utils";
import PeriodSelector from "../common/PeriodSelector";
import { AppState } from "../../types/AppState";
import ToolTip, { OBSERVATIONAL_PERIOD } from "../common/ToolTip";

const toIso = (period: string) => {
    return period.split("/").reverse().join("-")
}

function handleFromChange(queryId: number, toPeriod: string, newFromPeriod: string, dispatch: Dispatch) {
    const changes: {from: string, to?: string} = {from: newFromPeriod}
    if (toIso(newFromPeriod) > toIso(toPeriod)) {
        changes.to = newFromPeriod
    }

    dispatch(changeQueryPeriod({queryId, props: changes}))
}

function handleToChange(queryId: number, newToPeriod: string, dispatch: Dispatch) {
    dispatch(changeQueryPeriod({ queryId, props: { to: newToPeriod } }))
}

export const CohortPeriodSelector = ({response} : {response?: {[key: string]: any}}) => {
    const query = useSelector((state: AppState) => getCurrent(state).query!)
    const dispatch = useDispatch()
    const totalPatientCount = calculateTotalPatientCount(response)

    return <Row className={styles.periodSelector}>
        <Col span={6}>
            <label className={styles.periodSelectorLabel}>From</label>
            <PeriodSelector
                value={query.period.from}
                dataset={query.dataset}
                onChange={(value: string) => handleFromChange(query.id, query.period.to, value, dispatch)}
                disabled={response !== undefined}
                testId='from-obsevarion-period'
            />
        </Col>
        <Col className={styles.periodSelectorObservationalPeriod} span={12}>
            <span className={styles.periodSelectorObservationalPeriodText}>Observational Period<ToolTip content={OBSERVATIONAL_PERIOD} /></span><br/>
            <span className={styles.periodSelectorTitleSubText}>(Total Data Available)</span>
            {
                totalPatientCount !== undefined  && totalPatientCount !== parseInt(response?.count)?
                <>
                    <span className={styles.periodSelectorNumberOfPatients}>{totalPatientCount.toLocaleString('en-GB')}</span><br/>
                    <span className={styles.periodSelectorDescriptionText}>Total Patients</span>
                </>
                : ''
            }
        </Col>
        <Col span={6}>
            <Row justify="end">
                <Col>
                    <label className={styles.periodSelectorLabel}>To</label>
                    <PeriodSelector
                        value={query.period.to}
                        dataset={query.dataset}
                        onChange={(value: string) => handleToChange(query.id, value, dispatch)}
                        fromDate={query.period.from}
                        disabled={response !== undefined}
                        testId='to-obsevarion-period'
                    />
                </Col>
            </Row>
        </Col>
    </Row>
}